import { useState, useMemo, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import HeaderProfileBlock from '../sharedChild/headerImage/headerProfileBlock';
import ProductForm from './productForm';
import { initValueProduct } from '../../shared/initials';
import { getGridDataByModuleKey } from '../../redux/selector';
import { useDispatch, useSelector } from 'react-redux';
import { isLoadingByKey } from '../../shared/controls/methods/getLoadingState';
import cancel from '../../../src/assets/img/crm_home/header/cancel.png';
import save from '../../../src/assets/img/crm_home/header/save.png';
import apiServices from '../../services/service';
import { toast } from 'react-toastify';
import { validationSchemaProduct } from './productValidationSchema';
import { fetchDataAndUpdateStore, singleRowAddUpdateInStore } from '../../redux/actions';
import { productReferenceLookup } from '../../shared/constants';

export const AddProduct = () => {
  const containerStyle = useMemo(() => ({ width: '100%', height: '100%' }), []);
  const stateData = useSelector((state) => state);
  let storeLoading = isLoadingByKey(
    stateData,
    'revenueTypeList',
    'leadSourceList',
    'industryList',
    'timeZone'
  );
  const location = useLocation();
  const [formData, setFormData] = useState(initValueProduct);
  const [errormsg, setErrorMsg] = useState({});
  const [selectedOptions, setSelectedOptions] = useState({});
  const [loading, setLoading] = useState(storeLoading);
  const navigate = useNavigate();
  const gridData = useSelector(getGridDataByModuleKey('productList'));
  const [imagefile, setImageFile] = useState(null);
  const [formEdited, setFormEdited] = useState(false);
  const dispatch = useDispatch();

  useEffect(() => {
    let updatedFormData = {
      ...formData,
      type: location.pathname.includes('createProduct') ? 'add' : 'edit',
    };
    if (location.pathname.includes('editProduct') && location.state) {
      updatedFormData = {
        ...location.state,
        type: 'edit',
      };
    }
    setFormData(updatedFormData);
  }, [location]);

  const handleCloseAddForm = () => {
    if (formData.from === 'view') {
      navigate(`/products/productList/viewProduct?id=${formData.id}`);
    } else {
      navigate('/products/productList');
    }
  };

  const handleUploadImage = async (imagefile) => {
    setImageFile(imagefile);
    setFormEdited(true);
  };

  const handleChangeForm = (e) => {
    const { name, value } = e.target;
    let convertedValue = value;

    // For numeric-only fields
    if (
      [
        'quantityInDemand',
        'quantityOrdered',
        'quantityInStock',
        'reorderLevel',
        'commissionRate',
      ].includes(name)
    ) {
      convertedValue = value.replace(/[^0-9]/g, '');
    }

    // For unitPrice
    if (['unitPrice'].includes(name)) {
      if (value === '') {
        convertedValue = null; // Send null instead of empty string
      } else {
        let sanitized = value.replace(/[^0-9.]/g, '');

        const parts = sanitized.split('.');
        if (parts.length > 2) {
          sanitized = parts[0] + '.' + parts[1];
        }

        if (parts.length === 2) {
          parts[1] = parts[1].slice(0, 2);
          sanitized = parts[0] + '.' + parts[1];
        }

        const parsed = parseFloat(sanitized);
        convertedValue = !isNaN(parsed) && /^\d+(\.\d{1,2})?$/.test(sanitized) ? parsed : sanitized;
      }
    }

    // Clear the error for this field
    setErrorMsg((prev) => ({
      ...prev,
      [name]: undefined,
    }));

    // Update form data
    setFormData((prev) => ({
      ...prev,
      [name]: convertedValue,
    }));

    setFormEdited(true);
  };

  const handleLookupDropDownChange = (selectedId, selectedOption, name) => {
    const selectedValue = selectedOption.label;
    const isNew = selectedOption.__isNew__;
    setErrorMsg((prevErrorMsg) => ({
      ...prevErrorMsg,
      [name]: undefined,
    }));

    if (name === 'priceModelId') {
      setFormData({
        ...formData,
        priceModelId: selectedId,
        priceModel: selectedValue,
      });
      setFormEdited(true);
    } else if (name === 'productOwnerId') {
      setFormData({
        ...formData,
        productOwnerId: selectedId,
        productOwner: selectedValue,
      });
      setFormEdited(true);
    } else if (name === 'usageUnitId') {
      setFormData({
        ...formData,
        usageUnitId: selectedId,
        usageUnit: selectedValue,
      });
      setFormEdited(true);
    } else if (name === 'handlerId') {
      setFormData({
        ...formData,
        handlerId: selectedId,
        handler: selectedValue,
      });
      setFormEdited(true);
    } else if (name === 'handlerId') {
      setFormData({
        ...formData,
        handlerId: selectedId,
        handler: selectedValue,
      });
      setFormEdited(true);
    } else if (name === 'taxId') {
      setFormData({
        ...formData,
        taxId: selectedId,
        tax: selectedValue,
      });
      setFormEdited(true);
    } else if (name === 'vendorId') {
      setFormData((prev) => ({
        ...prev,
        vendorName: selectedValue,
        ...(isNew ? {} : { vendorId: selectedId }), // Only include ID if not new
      }));
    } else if (name === 'manufacturerId') {
      setFormData((prev) => ({
        ...prev,
        manufacturer: selectedValue,
        ...(isNew ? {} : { manufacturerId: selectedId }),
      }));
    } else if (name === 'productCategoryId') {
      setFormData((prev) => ({
        ...prev,
        productCategory: selectedValue,
        ...(isNew ? {} : { productCategoryId: selectedId }),
      }));
    }
  };

  const handleChange = (selectedOption, name) => {
    setSelectedOptions((prevState) => ({
      ...prevState,
      [name]: selectedOption,
    }));

    handleLookupDropDownChange(selectedOption.value, selectedOption, name);
  };

  const handleChangeCheckbox = (e) => {
    const { name, checked } = e.target; // Use 'checked' for true/false value
    setErrorMsg((prevErrorMsg) => ({
      ...prevErrorMsg,
      [name]: undefined,
    }));
    setFormData((prevFormData) => ({
      ...prevFormData,
      [name]: checked, // Set the checkbox state as true/false
    }));
    setFormEdited(true);
  };

  const updateList = async (msg, id) => {
    setLoading(false);

    toast.success(msg, {
      position: 'top-right',
    });

    const columnName = 'prodcutName';
    const orderType = 'desc';
    const data = {
      pageSize: parseInt(process.env.REACT_APP_DEFAULT_PAGESIZE),
      pageNumber: 1,
      columnName,
      orderType,
      filterJson: null,
    };

    try {
      // ✅ Await the dispatch before navigation
      // await dispatch(
      //   fetchDataAndUpdateStore({ key: "productList", inputData: data })
      // );
      dispatch(
        singleRowAddUpdateInStore({
          moduleName: 'Product',
          moduleKey: 'productList',
          id: formData.type === 'add' ? id : formData.id,
          rowIndex: formData.rowIndex,
        })
      );
      dispatch(
        fetchDataAndUpdateStore({
          key: 'productReferenceLookup',
          inputData: productReferenceLookup,
        })
      );
      if (formData.from === 'view') {
        navigate(`/products/productList/viewProduct?id=${formData.id}`);
      } else {
        navigate('/products/productList');
      }
    } catch (error) {
      toast.error('Something went wrong while updating the list.', {
        position: 'top-right',
      });
    }
  };

  const handleSubmit = async (formData) => {
    setLoading(true);
    try {
      const sanitizedData = {
        ...formData,
      };

      await validationSchemaProduct.validate(sanitizedData, {
        abortEarly: false,
      });
      handleFormSubmit(sanitizedData);
    } catch (error) {
      setLoading(false);
      const fieldErrors = {};
      error.inner.forEach((err) => {
        fieldErrors[err.path] = err.message;
      });
      setErrorMsg(fieldErrors);
    }
  };

  const handleFormSubmit = (formData) => {
    if (formData.type === 'add') {
      apiServices
        .createProduct(formData)
        .then((response) => {
          if (response.status === 200) {
            const id = response?.data;
            updateList('Product created successfully!', id);
            setLoading(false);
            handleCloseAddForm();
          } else {
            setLoading(false);
            const errorMessages = [];
            for (const key in response.errors) {
              if (response.errors.hasOwnProperty(key)) {
                const messages = response.errors[key];
                errorMessages.push(...messages);
              }
            }
            errorMessages.forEach((errorMessage) => {
              toast.error(errorMessage, { position: 'top-right' });
            });
          }
        })

        .catch((error) => {
          console.error('Error:', error, 'DataFormat:', formData);

          const formatFieldNames = (msg) => msg.replace(/([A-Z])/g, ' $1').trim(); // turns SaleEndDate -> Sale End Date

          if (error.response?.data?.errors) {
            const errors = error.response.data.errors;

            Object.values(errors).forEach((messages) => {
              messages.forEach((msg) => {
                toast.error(formatFieldNames(msg), { position: 'top-right' });
              });
            });
          } else {
            const fallbackMsg =
              error.response?.data?.title || error.message || 'An unexpected error occurred.';
            toast.error(fallbackMsg, { position: 'top-right' });
          }

          setLoading(false);
        });
    } else {
      apiServices
        .updateProduct(formData)
        .then((response) => {
          if (response.status === 200) {
            updateList('Product updated successfully!');
            setLoading(false);
            handleCloseAddForm();
          } else {
            setLoading(false);
            const errorMessages = [];
            for (const key in response.errors) {
              if (response.errors.hasOwnProperty(key)) {
                const messages = response.errors[key];
                errorMessages.push(...messages);
              }
            }
            errorMessages.forEach((errorMessage) => {
              toast.error(errorMessage, { position: 'top-right' });
            });
          }
        })

        .catch((error) => {
          console.error('Error:', error, 'DataFormat:', formData);

          const formatFieldNames = (msg) => msg.replace(/([A-Z])/g, ' $1').trim(); // turns SaleEndDate -> Sale End Date

          if (error.response?.data?.errors) {
            const errors = error.response.data.errors;

            Object.values(errors).forEach((messages) => {
              messages.forEach((msg) => {
                toast.error(formatFieldNames(msg), { position: 'top-right' });
              });
            });
          } else {
            const fallbackMsg =
              error.response?.data?.title || error.message || 'An unexpected error occurred.';
            toast.error(fallbackMsg, { position: 'top-right' });
          }

          setLoading(false);
        });
    }
  };

  return (
    <>
      <div className="inner-page" style={containerStyle}>
        <div id="product_page">
          <div className="viewHeader viewshadow">
            <HeaderProfileBlock
              localData={formData}
              moduleName={'Product'}
              uploadFile={handleUploadImage}
            />
            <div className="dsk">
              <div className="rightAction">
                <button
                  type="button"
                  className="btn btn-outline-primary"
                  data-bs-dismiss="modal"
                  onClick={handleCloseAddForm}
                >
                  Cancel
                </button>
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={() => {
                    handleSubmit(formData);
                  }}
                  disabled={loading || (formData.type === 'edit' && !formEdited)}
                >
                  {loading && (
                    <>
                      {' '}
                      <div class="spinner-border spinner-border-sm me-2" role="status"></div>
                    </>
                  )}
                  {loading ? 'Loading...' : 'Save'}
                </button>
              </div>
            </div>
            <div className="mob">
              <div className="rightAction">
                <button
                  type="button"
                  className="btn btn-outline-primary"
                  data-bs-dismiss="modal"
                  onClick={handleCloseAddForm}
                >
                  <img src={cancel} alt="Cancel" style={{ width: '12px', height: 'auto' }} />
                </button>
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={() => {
                    handleSubmit(formData);
                  }}
                  disabled={loading || (formData.type === 'edit' && !formEdited)}
                >
                  {loading ? (
                    <>
                      {' '}
                      <div class="spinner-border spinner-border-sm me-2" role="status"></div>
                    </>
                  ) : (
                    <img src={save} alt="Save" style={{ width: '13px', height: 'auto' }} />
                  )}
                </button>
              </div>
            </div>
          </div>

          <ProductForm
            formData={formData}
            selectedOptions={selectedOptions}
            handleSubmit={handleSubmit}
            handleChangeForm={handleChangeForm}
            handleChangeCheckbox={handleChangeCheckbox}
            handleChange={handleChange}
            errormsg={errormsg}
          />
        </div>
      </div>
    </>
  );
};

export default AddProduct;
